import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-success-stories-view-all',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (totalCount > limit) {
      <div class="cg-ss-view-all">
        <a [routerLink]="viewAllLink" class="cg-ss-view-all__btn">
          {{ label }} ({{ totalCount }})
        </a>
      </div>
    }
  `,
})
export class SuccessStoriesViewAllComponent {
  @Input({ required: true }) totalCount!: number;
  @Input() limit = 6;
  @Input() viewAllLink = '/success-stories/all';
  @Input() label = 'View All Success Stories';
}
